import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { DateField, TextField } from '../../fields';
import { poExtend, isValidDateTime } from '../../../utilities/validation';
import messages from '../../../text/messages';
import WizardButtons from '../../wizard/navigator/buttons';
import { isSameDay } from '../../../utilities/dateTime';

import './terminate.css';

class TerminateForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: true
        };

        this.isFormValid = this.isFormValid.bind(this);
    }

    isFormValid() {
        const { fields, initialValues, end_date } = this.props;
        return Object.keys(fields || {}).some(key => {
            if (key === 'end_date' && !isSameDay(initialValues.end_date, end_date)) return true;
            const getStringValue = obj => (obj ? obj.toString() : '');
            if (!key.includes('.') && getStringValue(initialValues[key]) !== getStringValue(this.props[key])) return true;

            return false;
        });
    }

    render() {
        const { onSubmit, handleSubmit, cancel, submitting, start_date, end_date } = this.props;

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <Field name={'user.first_name'} component={TextField} placeholder={messages.firstName} disabled={true} />
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <Field name="user.last_name" component={TextField} placeholder={messages.lastName} disabled={true} />
                    </div>

                    <div className="col-sm-6 col-xs-12">
                        <Field name="start_date" selectedDate={start_date} component={DateField} placeholder={messages.startDate} disabled={true} />
                    </div>

                    <div className="col-sm-6 col-xs-12">
                        <Field
                            name="end_date"
                            selectedDate={end_date || null}
                            validate={isValidDateTime}
                            component={DateField}
                            placeholder={messages.endDate}
                        />
                    </div>
                </div>

                <WizardButtons
                    disabled={submitting || !this.isFormValid()}
                    back={{ action: cancel, message: <FormattedMessage {...messages.cancel} /> }}
                    submit={{ message: <FormattedMessage {...messages.confirm} /> }}
                />
            </form>
        );
    }
}

TerminateForm.defaultProps = {
    job: {},
    onSubmit: undefined
};

TerminateForm.propTypes = {
    job: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired
};

TerminateForm = reduxForm({
    form: 'terminate-form',
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    keepDirtyOnReinitialize: false,
    validate: poExtend
})(TerminateForm);

const selector = formValueSelector('terminate-form');
const mapStateToProps = state =>
    Object.keys((state.form['terminate-form'] || { registeredFields: {} }).registeredFields).reduce(
        (props, key) => {
            if (!key.includes('.')) {
                props[key] = selector(state, key);
            }
            return props;
        },
        { fields: (state.form['terminate-form'] || { registeredFields: {} }).registeredFields }
    );
export default connect(mapStateToProps)(TerminateForm);



// WEBPACK FOOTER //
// ./src/components/forms/terminate/index.jsx